const LanewayCourses = [
    {
        value: null,
        label: '-'
    },
    {
        value: 'certificate-iv-in-business',
        label: 'CERTIFICATE IV IN BUSINESS',
        code: 'BSB40120'
    },
    {
        value: 'diploma-of-entrepreneurship-and-innovation',
        label: 'DIPLOMA OF ENTREPRENEURSHIP AND INNOVATION',
        code: '10733NAT'
    },
    {
        value: 'certificate-iv-in-marketing-and-communication',
        label: 'CERTIFICATE IV IN MARKETING AND COMMUNICATION',
        code: 'BSB40820'
    },
    {
        value: 'diploma-of-marketing-and-communication',
        label: 'DIPLOMA OF MARKETING AND COMMUNICATION',
        code: 'BSB50620'
    },
    {
        value: 'advanced-diploma-of-marketing-and-communication',
        label: 'ADVANCED DIPLOMA OF MARKETING AND COMMUNICATION',
        code: 'BSB60520'
    },
    {
        value: 'diploma-of-leadership-and-management',
        label: 'DIPLOMA OF LEADERSHIP AND MANAGEMENT',
        code: 'BSB50420'
    },
    {
        value: 'advanced-diploma-of-leadership-and-management',
        label: 'ADVANCED DIPLOMA OF LEADERSHIP AND MANAGEMENT',
        code: 'BSB60420'
    },
    {
        value: 'graduate-diploma-of-management-(learning)',
        label: 'GRADUATE DIPLOMA OF MANAGEMENT (LEARNING)',
        code: 'BSB80120'
    },
    {
        value: 'graduate-diploma-of-strategic-leadership',
        label: 'GRADUATE DIPLOMA OF STRATEGIC LEADERSHIP',
        code: 'BSB80320'
    },
    {
        value: 'diploma-of-project-management',
        label: 'DIPLOMA OF PROJECT MANAGEMENT',
        code: 'BSB50820'
    },
    {
        value: 'diploma-of-information-technology-(web-development)',
        label: 'DIPLOMA OF INFORMATION TECHNOLOGY (WEB DEVELOPMENT)',
        code: 'ICT50220'
    },
    {
        value: 'diploma-of-information-technology-(cyber-security)',
        label: 'DIPLOMA OF INFORMATION TECHNOLOGY (CYBER SECURITY))',
        code: 'ICT50220'
    },
]

export default LanewayCourses;